import { useState } from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { PanelEmptyMessage } from "@design-system/PanelEmptyMessage/PanelEmptyMessage";
import { VStack } from "@design-system/VStack/VStack";
import {
    BooleanControl,
    TextControl,
    VariantGrid,
    VariantItem,
} from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./FeedbackPlayground.module.scss";
import gridStyles from "./playgroundControls.module.scss";

export const EmptyStatesPlayground = () => {
    const [header, setHeader] = useState("No transactions found");
    const [hasDescription, setHasDescription] = useState(true);
    const [hasAction, setHasAction] = useState(true);
    const [emphasizeHeader, setEmphasizeHeader] = useState(true);
    const [interaction, setInteraction] = useState("None");

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Content</h2>
                        <TextControl
                            label="Header"
                            value={header}
                            onChange={setHeader}
                        />
                    </section>
                    <section>
                        <h2>Features</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Description"
                                checked={hasDescription}
                                onChange={setHasDescription}
                            />
                            <BooleanControl
                                label="Action"
                                checked={hasAction}
                                onChange={setHasAction}
                            />
                            <BooleanControl
                                label="Emphasize header"
                                checked={emphasizeHeader}
                                onChange={setEmphasizeHeader}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={interaction}
                width="full"
                output={JSON.stringify(
                    {
                        emptyState: {
                            header,
                            body: hasDescription,
                            action: hasAction,
                            emphasizeHeader,
                        },
                        panelEmptyMessage: {
                            children: "No matching transactions yet",
                        },
                        emptyValue: {},
                        showcaseInteraction: interaction,
                    },
                    null,
                    2,
                )}
            >
                <VStack gap={16} className={gridStyles.fillWidth}>
                    <VariantGrid title="EmptyState" columns="wide">
                        <VariantItem label="configured">
                            <EmptyState
                                header={header}
                                body={
                                    hasDescription
                                        ? "Try adjusting your filters or add a transaction."
                                        : undefined
                                }
                                ctaText={
                                    hasAction ? "Clear filters" : undefined
                                }
                                action={
                                    hasAction
                                        ? () =>
                                              setInteraction("Filters cleared")
                                        : undefined
                                }
                                emphasizeHeader={emphasizeHeader}
                            />
                        </VariantItem>
                        <VariantItem label="header only">
                            <EmptyState
                                header="No activity history"
                                ctaText={undefined}
                            />
                        </VariantItem>
                    </VariantGrid>
                    <VariantGrid title="PanelEmptyMessage" columns="wide">
                        <VariantItem label="panel message">
                            <PanelEmptyMessage>
                                No matching transactions yet
                            </PanelEmptyMessage>
                        </VariantItem>
                    </VariantGrid>
                    <VariantGrid title="EmptyValue" columns="auto">
                        <VariantItem label="missing table value">
                            <EmptyValue />
                        </VariantItem>
                    </VariantGrid>
                </VStack>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
